import { useEffect, useRef, useState } from "react";
import domain from "../../../../reusecomponent/domain";
import { ErrorToastContainer, fetchTemplateDetails, SuccessToastContainer, WorningToastContainer } from "../../../function/CustomFunction";
import { getToken } from "../../../function/token";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router-dom";

function Googlesheet() {
  const { id } = useParams();
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const sheetdataRef = useRef("");
  const [responsedate,setresponsedate] = useState(null);
  const [step,setStep] = useState(0);
  const [templates,setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const fileType = useRef(null);
  const fileUrl = useRef("");
  const [templateVariables, setTemplateVariables] = useState({});
  const [loadingTemplates, setLoadingTemplates] = useState(false);
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [testnumber,setTestnumber] = useState("");
  const testnumberKeyRef = useRef("");

  useEffect(() => {
    console.log("Mahadev");
    console.log(testnumberKeyRef.current);
  },[testnumber]);

  useEffect(()=>{
    if(id !== undefined){
      // id = atob(id);
      GetGoogleSheet(id);
    }
  },[]);

  useEffect(() => {
    let isValid = true;
    for (const key in templateVariables) {
        const { value_type, value, content_type } = templateVariables[key];
        if (!["STATIC", "DYNAMIC"].includes(value_type)) {
          isValid = false;
          break;
        }

        if(key === 'header' && (content_type === 'IMAGE' || content_type === 'VIDEO' || content_type === 'DOCUMENT') && value_type === 'STATIC'){
          try {
            new URL(value);
          } catch (e) {
            isValid = false;
            break;
          }
        }

        if((value === null || value === '') && value_type === 'STATIC'){
            isValid = false;
            break;
        }
        
        if((value === null || value === '') && value_type === 'DYNAMIC'){
            isValid = false;
            break;
        }
    }
    if(isValid && step === 3){
      setStep(4);
    }else if(!isValid && step === 4){
      setStep(3);
    }
  },[templateVariables]);


  useEffect(() => {
    if(step === 1){
      const intervalId = setInterval(() => {
        fetch(`${domain()}/marketplace/googlesheet/${btoa(sheetdataRef.current.id)}`,{
          headers: myHeaders,
        })
          .then(res => res.json())
          .then(data => {
            if(!data.status){
              clearInterval(intervalId);
              ErrorToastContainer(data.message);
            }else{
              if(data.data !== null){
                const decodedData = typeof data.data === "string" ? JSON.parse(data.data) : data.data;
                clearInterval(intervalId);
                setresponsedate(decodedData);
                setStep(2);
              }
            }
          })
          .catch(err => {
            ErrorToastContainer("something went wrong!");
            clearInterval(intervalId);
          });
      }, 3000);
    }else if(step === 2){
      GetTemplate();
    }
  }, [step]);


  let initialVariableValue = {
    'value_type' : "",
    'value' : null,
    "content_type" : null
  }

  const access_token = getToken();
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${access_token}`);

  let GetGoogleSheet = async (id) =>{
      try {
        setLoading(true);
        const response = await fetch(`${domain()}/marketplace/googlesheet/manage/${id}`, {
          method: 'GET',
          headers: myHeaders
        });
  
        const data = await response.json();
        if (data.status) {
          if(data.data.google_sheets_value != null){
              sheetdataRef.current = data.data;
              setresponsedate(JSON.parse(data.data.google_sheets_value));
              setStep(2);
          }else{
              setStep(1);
              sheetdataRef.current = data.data;
          }
          setName(data.data.sheet_name);
        } else {
          WorningToastContainer(data.message);
        }
      } catch (error) {
        setLoading(false);
        ErrorToastContainer('Error fetching templates');
      }finally{
          setLoading(false);
      }
  }

  const handleImageUpload = async (file,content_type) => {
    if (!file) return;
    setIsUploadingImage(true);
    try {
      const token = getToken();
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(`${domain()}/campaign/uplode-file`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const result = await response.json();
      
      if (result.status) {
        const imageUrl = result.data || '';
        fileUrl.current = imageUrl;
        if (fileUrl.current === '') {
          WorningToastContainer("Please Select Valid File Url");
          return;
        }
        handleVariableMapping('header','STATIC',imageUrl,content_type);
      } else {
        ErrorToastContainer(result.message || 'Failed to upload image');
      }
    } catch (error) {
      ErrorToastContainer('Error uploading image. Please try again.');
    } finally {
      setIsUploadingImage(false);
    }
  };

  const handleVariableMapping = (variable,valueType,mappedValue,content_type) => {
    let newobj;
    if(mappedValue === undefined){
      newobj = {
        'value_type' : valueType,
        'value' : null,
        'content_type': null,
      }
    }else{
      if(valueType === 'STATIC'){
        newobj = {
          'value_type' : valueType,
          'value' : mappedValue,
          'content_type': content_type,
        }
      }else{
        newobj = {
          'value_type' : valueType,
          'value' : mappedValue,
          'content_type': content_type,
        }
      }
    }

    setTemplateVariables(prev => ({
      ...prev,
      [variable]: newobj
    }));
  };

  const handleTemplateSelection = async (template) => {
    if(selectedTemplate !== null && selectedTemplate.id === template.id){
      return;
    }
   
    const detailedTemplate = await fetchTemplateDetails(template.id);
    if (detailedTemplate && detailedTemplate.status) {
      const detailedData = detailedTemplate.data;
      setSelectedTemplate(detailedTemplate.data);
      let templateVariables = {};
      
      if (detailedData.components) {
        try {
          const components = Array.isArray(detailedData.components)
            ? detailedData.components
            : JSON.parse(detailedData.components);
          components.forEach((component) => {
            if (component.type === "HEADER") {
              fileType.current = null;
              if(component.format === 'TEXT' && component.text) {
                const matches = component.text.match(/\{\{(\d+)\}\}/g) || [];
                matches.forEach((m) => {
                  const uniqueKey = `header`;
                  templateVariables[uniqueKey] = initialVariableValue;
                });
              }else if (component.format === 'IMAGE') {
                fileType.current = 'IMAGE';
                templateVariables['header'] = {
                  'value_type' : 'STATIC',
                  'value' : null,
                  'content_type': 'IMAGE',
                };
              }else if (component.format === 'VIDEO') {
                fileType.current = 'VIDEO';
                templateVariables['header'] = {
                  'value_type' : 'STATIC',
                  'value' : null,
                  'content_type': 'VIDEO',
                };
              }else if (component.format === 'AUDIO') {
                fileType.current = 'AUDIO';
                templateVariables['header'] = {
                  'value_type' : 'STATIC',
                  'value' : null,
                  'content_type': 'AUDIO',
                };
              }else if (component.format === 'LOCATION') {
                WorningToastContainer("Template in Location not allowed");
                setStep(step-1)
                return;
                templateVariables['header'] = '';
              }else if (component.format === 'DOCUMENT') {
                fileType.current = 'DOCUMENT';
                 templateVariables['header'] = {
                  'value_type' : 'STATIC',
                  'value' : null,
                  'content_type': 'DOCUMENT',
                };
              }
            } else if (component.type === "BODY" && component.text) {
              const matches = component.text.match(/\{\{(\d+)\}\}/g) || [];
              matches.forEach((m) => {
                const idx = m.replace(/[^\d]/g, "");
                const uniqueKey = `body_${idx}`;
                templateVariables[uniqueKey] = initialVariableValue;
              });
            }
          });
        } catch (error) {
          console.error('Error parsing components JSON:', error);
        }
      }

      setTemplateVariables(templateVariables);
    } else {
      // Fallback to original template data if detailed fetch fails
      
      let templateVariables = {};
      if (template.variables && template.variables.length > 0) {
        template.variables.forEach(variable => {
          templateVariables[variable] = '';
        });
      } else {
        // Try to extract variables from template content
        const content = `${template.header || ''} ${template.body || ''} ${template.footer || ''}`;
        const variableMatches = content.match(/\{([^}]+)\}|\$\{([^}]+)\}/g);
        if (variableMatches) {
          variableMatches.forEach(match => {
            const variableName = match.replace(/[{}]/g, '').replace(/\$\{([^}]+)\}/, '$1');
            templateVariables[variableName] = '';
          });
        }
      }
      setTemplateVariables(templateVariables);
    }
  };

  let GetTemplate = async () =>{
    if(templates.length !== 0){
      setStep(3);
      return;
    }
      try {
        const response = await fetch(`${domain()}/manage-template`, {
          method: 'GET',
          headers: myHeaders
        });
  
        const data = await response.json();
        if (data.status) {
          const approvedTemplates = (data?.data || []).filter(
              item => item.status === "APPROVED" && (item.category === 'MARKETING' || item.category === 'UTILITY') 
          );
          setTemplates(approvedTemplates);
          if(id !== undefined && sheetdataRef.current.template_id !== null){
            const filterTemplates = approvedTemplates?.find(
              item => String(item.id) === String(sheetdataRef.current.template_id)
            );
            if(filterTemplates !== undefined){
              setSelectedTemplate(filterTemplates);
              if(sheetdataRef.current.template_variables){
                setTemplateVariables(JSON.parse(sheetdataRef.current.template_variables));
                testnumberKeyRef.current = sheetdataRef.current.number_variable;
                setTestnumber(responsedate[sheetdataRef.current.number_variable]);
              }
        
            }
          }
        } else {
          WorningToastContainer(data.message);
        }
      } catch (error) {
        ErrorToastContainer('Error fetching templates');
      } finally {
        setStep(3);
      }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      setError("Name is required");
      return;
    }

    setError("");
    setLoading(true);
    const formdata = new FormData();
    formdata.append("sheet_name", name);

      fetch(`${domain()}/marketplace/googlesheet`, {
        method: "POST",
        headers: myHeaders,
        body: formdata,
      })
      .then((response) => response.json())
      .then((result) => {
        if (!result.status) {
          ErrorToastContainer(result.message);
        } else {
          SuccessToastContainer("Google Sheet token generated successfully!");
          setStep(1);
          sheetdataRef.current = result.data;
        }
      })
      .catch(() => {
        ErrorToastContainer("something went wrong!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const listenAgain = async () => {
    if (!name.trim()) {
      setError("Name is required");
      return;
    }

    setError("");
    setLoading(true);

      fetch(`${domain()}/marketplace/googlesheet/listenagain/${btoa(sheetdataRef.current.id)}`, {
        method: "GET",
        headers: myHeaders,
      })
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          SuccessToastContainer(result.message);
          setresponsedate("");
          setSelectedTemplate(null)
          setTemplateVariables({});
          setTestnumber("");
          testnumberKeyRef.current = "";
          setStep(1);
        } else {
          ErrorToastContainer(result.message);
        }
      })
      .catch((e) => {
        ErrorToastContainer("something went wrong!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const copyToken = () => {
    navigator.clipboard.writeText(sheetdataRef.current.token);
    SuccessToastContainer("Token copied to clipboard!");
  };

  const TestNumberSelect = (e) => {
    let variable = e.target.value;
    if(responsedate[variable] !== undefined){
      setTestnumber(responsedate[variable]);
      testnumberKeyRef.current = variable;
    }
  }

  const Test = () => {
    const phoneRegex = /^[1-9]\d{7,14}$/;
    function isValidMobile(number) {
      return phoneRegex.test(number);
    }
    if(!isValidMobile(testnumber)){
      ErrorToastContainer("Select Valid Number");
      return;
    }

    setLoading(true);
    const formdata = new FormData();
    formdata.append("google_sheets_value", JSON.stringify(responsedate));
    formdata.append("template_id", selectedTemplate.id);
    formdata.append("phonenumber_variable", testnumberKeyRef.current);
    formdata.append("templateVariables", JSON.stringify(templateVariables));

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow"
    };

    fetch(`${domain()}/marketplace/googlesheet/testmessage`, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      if(result.status){
          SuccessToastContainer(result.message)
          setStep(5);
      }else{
          WorningToastContainer(result.message);
      }
    })
    .catch(() => ErrorToastContainer("Internal Server Problem"))
    .finally(()=>{
      setLoading(false)
    });
  }

  const Configure = () => {
    const phoneRegex = /^[1-9]\d{7,14}$/;
    function isValidMobile(number) {
      return phoneRegex.test(number);
    }
    if(!isValidMobile(testnumber)){
      ErrorToastContainer("Select Valid Number");
      return;
    }

    setLoading(true);
    const formdata = new FormData();
    formdata.append("google_sheets_value", JSON.stringify(responsedate));
    formdata.append("template_id", selectedTemplate.id);
    formdata.append("id", sheetdataRef.current.id);
    formdata.append("phonenumber_variable", testnumberKeyRef.current);
    formdata.append("templateVariables", JSON.stringify(templateVariables));

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow"
    };

    fetch(`${domain()}/marketplace/googlesheet/configure`, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      if(result.status){
          SuccessToastContainer(result.message);
          setTimeout(() => {
            window.location.reload();
          },2000)
      }else{
          WorningToastContainer(result.message);
      }
    })
    .catch(() => ErrorToastContainer("Internal Server Problem"))
    .finally(()=>{
      setLoading(false)
    });
  }

  return (
    <div className="container-fluid dashboard-main pt-0">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title mb-4">
            Google Sheet Integration
          </h4>
          <div className="row my-1">
            <div className="col-md-6">
                 <div className="border rounded p-3 bg-light">
                    <label className="form-label fw-semibold">
                      Sheet name
                    </label>
                    <form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter sheet name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          disabled={step}
                        />
                      </div>

                      {error && (
                        <div className="text-danger mb-2">
                          {error}
                        </div>
                      )}

                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading || step}
                      >
                        {loading  && step === 0 ? "Submitting..." : "Submit"}
                      </button>
                    </form>
                 </div>
            </div>

            <div className="col-md-6">
              {step >= 1 && (
                <div className="border p-3 rounded bg-light pb-4">
                  <label className="form-label fw-semibold">
                    Generated Token
                  </label>

                  <div className="input-groupd bg-transparent px-0 d-flex justify-content-between">
                    <input
                      type="text"
                      className="form-control"
                      value={sheetdataRef.current.token}
                      style={{borderRadius: "0px"}}
                      readOnly
                    />
                    <div style={{width: "55px"}}>
                      <button
                      className="btn-outline-secondary border border-1 px-2"
                      type="button"
                      onClick={copyToken}
                      style={{height: "100%"}}
                    >
                      copy
                    </button>
                    </div>
                  </div>

                  <small className="text-muted d-block mt-4">
                    keep this token secure. it will be used for google sheet integration.
                  </small>
                  
                </div>
              )}
            </div>
          </div>

          {step === 1 && (
            <div className="row my-1">
              <div className="col-12">
                <div className="border rounded p-4 bg-light text-center">
                  <div className="fw-semibold mb-2">
                      Listening for incoming Google Sheets data
                  </div>
                  <div className="text-muted">
                    Please wait while we prepare your configuration...
                  </div>
                </div>
              </div>
            </div>
          )}

          {step >= 2 && responsedate && (
            <div className="row my-2">
              <div className="col-12">
                <div className="border rounded p-4 bg-light">
                  <div className="fw-semibold mb-3 d-flex justify-content-between">
                    <p></p>
                    <p>Listening for incoming Google Sheets data</p>
                    <FontAwesomeIcon icon={faRefresh} style={{cursor: "pointer",fontSize: "20px"}} onClick={() => {
                        listenAgain();
                    }}/>
                  </div>

                  {Object.entries(responsedate).map(([key, value]) => (
                    <div className="row mb-2 align-items-center" key={key}>
                      {/* LEFT SIDE → KEY */}
                      <div className="col-md-4 fw-semibold text-capitalize">
                        {key}
                      </div>

                      {/* RIGHT SIDE → VALUE */}
                      <div className="col-md-8">
                        <input
                          type="text"
                          className="form-control"
                          value={value ?? ''}
                          readOnly
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {step >= 3 && (
            <>
            <div className="row my-2">
                <div className="form-group mt-4">
                  <label className="form-label fw-semibold">
                    Select Template 
                  </label>
                  {loadingTemplates ? (
                    <div className="text-center py-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-2 text-muted">Loading templates...</p>
                    </div>
                  ) : templates.length > 0 ? (
                    <>
                    <div className="col p-0">
                      <select
                        className="form-select form-select-sm"
                        value={selectedTemplate?.id || ""}
                        onChange={(e) => {
                          const selectedId = e.target.value;
                          const template = templates.find(t => parseInt(t.id) === parseInt(selectedId));

                          if (template) {
                            setSelectedTemplate({ id: selectedId });
                            handleTemplateSelection(template);
                          }
                        }}
                      >
                        <option value="">Select Template</option>

                        {templates.map((template) => (
                          <option value={template.id} key={template.id}>
                            {template.template_name || "Unnamed Template"}
                          </option>
                        ))}
                      </select>
                    </div>
                        </>
                  ) : (
                    <div className="text-center py-4">
                      <p className="text-muted">No templates available</p>
                    </div>
                  )}
                </div>
            </div>
            
            {/* Template variable */}
            {Object.keys(templateVariables).length > 0 && (
            <div className="m-0 p-0 mt-5">
                <h5 className="fw-semibold">Map Template Variables</h5>
                <p className="text-muted mb-3">
                  Map template variables to incoming Google Sheets fields or use static values
                </p>
                <div className="row g-3 m-0 p-0">
                  {Object.keys(templateVariables).map((variable, index) => {
                    return (
                      <div key={index} className="cosl-12 p-0 m-0 p-0 my-1">
                        <div className="card-body card m-0 p-0 px-2">
                          <div className="row align-items-center align-content-center justify-content-between m-0 py-1 pb-2">

                            {/* sl print */}
                            <div className="col-md-3">
                              <label className="form-label fw-semibold mb-0">
                                {variable.startsWith('header') ? `Header` : variable.startsWith('body_') ? `Body Variable ${variable.split('_')[1]}` : `Variable ${index + 1}`}:
                              </label>
                            </div>

                            {/* value type print */}
                            {(variable === 'header' && (fileType.current === 'IMAGE' || fileType.current === 'VIDEO' || fileType.current === 'DOCUMENT')) ? (
                              <div className="col-md-3 p-0">
                                <label className="form-label small mb-1">Select Value Type</label>
                                <select
                                  className="form-select form-select-sm"
                                  value={templateVariables[variable]['value_type'] === 'STATIC' ? "STATIC" : (templateVariables[variable]['value_type'] === "DYNAMIC" ? "DYNAMIC" : "")}
                                  disabled={true}
                                >
                                  <option value="STATIC">Static</option>
                                </select>
                              </div>
                            ) : (
                              <div className="col-md-3 p-0">
                                <label className="form-label small mb-1">Select Value Type2</label>
                                <select
                                  className="form-select form-select-sm"
                                  value={templateVariables[variable]['value_type'] === 'STATIC' ? "STATIC" : (templateVariables[variable]['value_type'] === "DYNAMIC" ? "DYNAMIC" : "")}
                                  onChange={(e) => {
                                    if (e.target.value === "STATIC") {
                                      handleVariableMapping(variable,e.target.value);
                                    } else if (e.target.value === "DYNAMIC") {
                                      handleVariableMapping(variable,e.target.value);
                                    }
                                  }}
                                >
                                  <option value="">Select Value Type</option>
                                  <option value="STATIC">Static</option>
                                  <option value="DYNAMIC">Dynamic</option>
                                </select>
                              </div>
                            )}
           

                            {/* only for header */}
                             {((templateVariables[variable]['value_type'] === 'STATIC' && variable === 'header') && (fileType.current === 'IMAGE' || fileType.current === 'VIDEO' || fileType.current === 'DOCUMENT' || fileType.current === 'AUDIO')) && (
                               <>
                                 <div className="col-md-3 p-0">
                                   <label className="form-label small mb-1">{`Upload ${fileType.current}`}</label>
                                   <input
                                     type="file"
                                     className="form-control form-control-sm"
                                     accept={
                                       fileType.current === "IMAGE"
                                         ? "image/*"
                                         : fileType.current === "VIDEO"
                                         ? "video/*"
                                         : fileType.current === "AUDIO"
                                         ? "audio/*"
                                         : fileType.current === "DOCUMENT"
                                         ? "*/*"
                                         : ""
                                     }
                                     onChange={(e) =>
                                       handleImageUpload(
                                         e.target.files[0],
                                         fileType.current === null ? "TEXT" : fileType.current
                                       )
                                     }
                                     disabled={isUploadingImage}
                                   />

                                   {isUploadingImage && (
                                     <small className="text-muted">Uploading...</small>
                                   )}
                                 </div>
                                 <div className="col-md-2">
                                   <label className="form-label small mb-1">File URL:</label>
                                   <input
                                     type="url"
                                     required
                                     readOnly
                                     pattern="https?://.*"
                                     className="form-control form-control-sm py-2"
                                     placeholder="File URL will appear here"
                                     value={fileUrl.current}
                                   />
                                 </div> 
                               </>
                             )}


                            {/* that have for header and body */}
                            {(templateVariables[variable]['value_type'] === 'STATIC' && (variable.startsWith('body') || (variable === 'header' && fileType.current === null))) &&((
                              <div className="col-md-3 p-0">
                                <label className="form-label small mb-1">Enter Static Value: {templateVariables[variable]['value_type']}</label>
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  placeholder="Enter static value"
                                  value={templateVariables[variable]['value'] || ''}
                                  onChange={(e) => {
                                    handleVariableMapping(variable,templateVariables[variable]['value_type'],e.target.value,fileType.current === null ? 'TEXT' : fileType.current)
                                  }}
                                />
                              </div>
                            ))}

                            {/* dynamic select place that have for header and body*/}
                            {templateVariables[variable]['value_type'] === 'DYNAMIC' &&((
                              <div className="col-md-3 p-0">
                                <label className="form-label small mb-1">Map to Google Sheet Field:</label>
                                <select 
                                  className="form-select form-select-sm"
                                  value={templateVariables[variable]['value'] || ''}
                                  onChange={(e) => {
                                    console.log(fileType.current);
                                    handleVariableMapping(variable,templateVariables[variable]['value_type'],e.target.value,fileType.current === null ? 'TEXT' : fileType.current)
                                  }}
                                >
                                  <option value="">Select Google Sheet Field Data</option>
                                  {Object.entries(responsedate).map(([key, value]) => (
                                    <option value={key} key={key}>
                                      {key} : {value}
                                    </option>
                                  ))}

                                </select>
                              </div>
                            ))}

                            {(templateVariables[variable]['value_type'] === '') &&((
                              <div className="col-md-3 p-0">
                              </div>
                            ))}


                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            </>
          )}
   
          {step >= 4 && (
            <div className="row my-2">
              <div className="col-12">
                <div className="border rounded p-4 bg-light">
                  <div className="fw-semibold mb-3 text-center">
                    Listening for incoming Google Sheets data
                  </div>

                  <div className="row mb-2 align-items-center">
                    <div className="col-md-4 mb-2">
                      <input
                        type="number"
                        value={testnumber}
                        className="form-control"
                        placeholder="Enter mobile number"
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-5 mb-2">
                      <select className="form-select" onChange={TestNumberSelect} value={testnumberKeyRef.current}>
                        <option value="">Select field</option>
                          {Object.entries(responsedate).map(([key, value]) => (
                          <option value={key} key={key}>
                            {key} : {value}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* RIGHT → Test Button */}
                    {step === 4 ? (
                      <div className="col-md-3 text-end mb-2">
                        <button className="btn btn-sm btn-primary w-100" onClick={Test} disabled={loading && step === 4 ? true : false}>
                          {loading && step === 4 ? "Testing..." : "Test"}
                        </button>
                      </div>
                    ):(
                    <div className="col-md-3 text-end mb-2" onClick={Configure} disabled={loading && step === 5 ? true : false}>
                      <button className="btn btn-sm btn-primary w-100">
                        {loading && step === 5 ? "Configure..." : "Configure"}
                      </button>
                    </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}

export default Googlesheet;